import config from '@/config'
/**
 * 获取当前Access Token
 */
export const getToken = () => {
  return localStorage.getItem(config.accessToken)?localStorage.getItem(config.accessToken):'';
}
/**
 * 退出清除Token
 */
export const clearToken = () => {
  localStorage.removeItem(config.accessToken);
  localStorage.removeItem('loggedIn')
  localStorage.removeItem('userRole')
  return true;
}

/**
 * 监听stroage事件
 */
export const dispatchEventStroage = () => {
  const signSetItem = localStorage.setItem
  localStorage.setItem = function (key, val) {
    let setEvent = new Event('setItemEvent')
    setEvent.key = key
    setEvent.newValue = val
    window.dispatchEvent(setEvent)
    signSetItem.apply(this, arguments)
  }
}
